import { render, staticRenderFns } from "./surplusStore.vue?vue&type=template&id=5d866e52&scoped=true&"
import script from "./surplusStore.vue?vue&type=script&lang=js&"
export * from "./surplusStore.vue?vue&type=script&lang=js&"
import style0 from "./surplusStore.vue?vue&type=style&index=0&id=5d866e52&prod&scoped=true&lang=less&"
import style1 from "./surplusStore.vue?vue&type=style&index=1&id=5d866e52&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d866e52",
  null
  
)

export default component.exports